import { performFetchRequest } from './common';

export const getEmailSettings = async (jwt) => {
  return await performFetchRequest(`/email/settings`, {
    headers: {
      'x-access-token': jwt
    }
  });
};

export const updateEmailSettings = async (jwt, emailSettings) => {
  return await performFetchRequest(`/email/settings`, {
    method: 'POST',
    headers: {
      'x-access-token': jwt,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(emailSettings)
  })
};

export const unsubscribeFromMarketing = async (emailAddress, emailType) => {
  return await performFetchRequest('/email/unsubscribe-marketing', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      emailAddress,
      emailType,
    })
  });
};

export const unsubscribeFromMarketingViaEmailId = async (emailId, emailType) => {
  return await performFetchRequest('/email/unsubscribe-marketing-via-eid', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      emailId,
      emailType,
    })
  });
};

export const sendPrizeChoiceToTeam = async (userId, prizeCategory, prizeTitle, selectedOptionName, selectedOptionTitle, drawId, additionalPromptInfo) => {
  return await performFetchRequest('/email/send-prize-choice-to-team', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      userId,
      prizeCategory,
      prizeTitle,
      selectedOptionName,
      selectedOptionTitle,
      drawId,
      additionalPromptInfo
    })
  });
};

export const subscribeForTruTravelsMailingList = async (emailAddress) => {
  return await performFetchRequest('/email/subscribe-for-trutravels-mailing-list', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      emailAddress
    })
  });
};
